import { useEffect, useState } from 'react'

/** Subscribes to a media query. SSR-safe: reports `false` before the first effect. */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState<boolean>(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  )

  useEffect(() => {
    const list = window.matchMedia(query)
    const onChange = (event: MediaQueryListEvent): void => {
      setMatches(event.matches)
    }
    setMatches(list.matches)
    list.addEventListener('change', onChange)
    return () => {
      list.removeEventListener('change', onChange)
    }
  }, [query])

  return matches
}

/** Below the md breakpoint the rail becomes a bottom bar and the Now Rail collapses. */
export const useIsMobile = (): boolean => useMediaQuery('(max-width: 767px)')

export const useIsCompact = (): boolean => useMediaQuery('(max-width: 1023px)')

/** Honours the OS setting. Motion must never be the only channel carrying meaning. */
export const usePrefersReducedMotion = (): boolean =>
  useMediaQuery('(prefers-reduced-motion: reduce)')
